import React from 'react';
import styled from '@emotion/styled/macro';
import { VerticalGraphScaleProps } from './vertical-bar-graph.types';

const VerticalGraphScale: React.FC<VerticalGraphScaleProps> = ({
  className,
}) => {
  return (
    <svg
      width="43"
      height="170"
      viewBox="0 0 43 170"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* <rect width="42.1053" height="170" fill="#F2F2F2" /> */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.8947 88.495L11.842 88.495L11.842 87.1458L28.8947 87.1458L28.8947 88.495Z"
        fill="#666666"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.8947 3.46957L11.842 3.46957L11.842 2.12036L28.8947 2.12036L28.8947 3.46957Z"
        fill="#666666"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.6842 20.8673L17.1052 20.8673L17.1052 19.5181L23.6842 19.5181L23.6842 20.8673Z"
        fill="#CCCCCC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.6842 37.7743L17.1052 37.7743L17.1052 36.425L23.6842 36.425L23.6842 37.7743Z"
        fill="#CCCCCC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.6842 54.681L17.1052 54.681L17.1052 53.3318L23.6842 53.3318L23.6842 54.681Z"
        fill="#CCCCCC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.6842 71.588L17.1052 71.588L17.1052 70.2388L23.6842 70.2388L23.6842 71.588Z"
        fill="#CCCCCC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.6842 105.402L17.1052 105.402L17.1052 104.052L23.6842 104.052L23.6842 105.402Z"
        fill="#CCCCCC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.6842 122.309L17.1052 122.309L17.1052 120.959L23.6842 120.959L23.6842 122.309Z"
        fill="#CCCCCC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.6842 139.216L17.1052 139.216L17.1052 137.866L23.6842 137.866L23.6842 139.216Z"
        fill="#CCCCCC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.6842 156.123L17.1052 156.123L17.1052 154.773L23.6842 154.773L23.6842 156.123Z"
        fill="#CCCCCC"
      />
    </svg>
  );
};

const VerticalGraphScaleAtom = styled(VerticalGraphScale)``;

export default VerticalGraphScaleAtom;
